// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/sass/style.scss
// module id = 2
// module chunks = 0